export const movieData = [
  {
    id: "kalki",
    name: "Kalki 2898 AD",
    ratings: "8.6/10",
    votes: "671.3k",
    movieType: "Action,Sci-Fi,Thriller",
    poster:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/thumbnail/xlarge/kalki-2898-ad-et00352941-1718275859.jpg",
    language: ["Telugu", "Kannada", "Malayalam", "Hindi", "Tamil"],
    showIn: ["2D", "IMAX 2D", "3D", "IMAX 3D"],
    duration: "3h 1m",
    releaseDate: "27 Jun, 2024",
    atm: "When the world is taken over darkness. A force will rise",
    movieThumbnail:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/listing/xxlarge/kalki-2898-ad-et00352941-1718275859.jpg",
  },
  {
    id: "deadpool-wolverine",
    name: "Deadpool & Wolverine",
    ratings: "8.6/10",
    votes: "428.3k",
    movieType: "Action,Adventure,Comedy",
    poster:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/thumbnail/xlarge/deadpool-and-wolverine-et00341295-1718018322.jpg",
    language: ["English", "Hindi", "Tamil", "Telugu"],
    showIn: ["2D", "IMAX 2D", "3D", "IMAX 3D"],
    duration: "2h 8m",
    releaseDate: "26 Jul, 2024",
    atm: "Marvel Studios` `Deadpool & Wolverine` delivers the ultimate, iconic, cinematic team-up throwdown on July 26.",
    movieThumbnail:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/listing/xxlarge/deadpool-and-wolverine-et00341295-1718018322.jpg",
  },
  {
    id: "bad-newz",
    name: "Bad Newz",
    ratings: "6/10",
    votes: "14.9k",
    movieType: "Comedy, Drama",
    poster:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/thumbnail/xlarge/bad-newz-et00391805-1721214274.jpg",
    language: ["Hindi"],
    showIn: ["2D"],
    duration: "2h 22m",
    releaseDate: "19 Jul, 2024",
    atm: "Bad Newz is a bizarre, rare comedy about heteropaternal superfecundation! A twist of fate leads to Saloni Bagga`s twin pregnancy being fathered by both Akhil Chadha and Gurbir Pannu, setting off a chaotic rivalry for her love and their children. As Akhil and Gurbir vie for Saloni`s affections, chaos ensues.",
    movieThumbnail:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/listing/xxlarge/bad-newz-et00391805-1721214274.jpg",
  },
  {
    id: "kill",
    name: "Kill",
    ratings: "9/10",
    votes: "36.9k",
    movieType: "Action, Thriller",
    poster:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/thumbnail/xlarge/kill-et00374797-1718179453.jpg",
    language: ["Hindi"],
    showIn: ["2D"],
    duration: "1h 46m",
    releaseDate: "5 Jul, 2024",
    atm: "Army commando Amrit (Lakshya) finds out his true love Tulika (Tanya Maniktala) is en-route, he boards a New Delhi-bound train in a daring quest to derail the their eventual seperation. But when a gang of knife-wielding thieves led by the ruthless leader (Raghav Juyal) begin to terrorize innocent passengers on his train, Amrit takes them on himself in a death-defying kill-spree to save those around him - turning what should have been a typical commute into an adrenaline-fueled thrill ride.",
    movieThumbnail:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/listing/xxlarge/kill-et00374797-1718179453.jpg",
  },
  {
    id: "despicable-me-4",
    name: "Despicable Me 4",
    ratings: "8.4/10",
    votes: "8.7k",
    movieType: "Action, Adventure, Animation, Comedy",
    poster:
      "https://assets-in.bmscdn.com/iedb/movies/images/extra/vertical_logo/mobile/thumbnail/xxlarge/despicable-me-4-et00386901-1724235181.jpg",
    language: ["English", "Hindi", "Tamil", "Telugu"],
    showIn: ["2D", "3D", "IMAX 3D"],
    duration: "1h 34m",
    releaseDate: "5 Jul, 2024",
    atm: "Gru welcomes a new member to the family, Gru Jr., who's intent on tormenting his dad. However, their peaceful existence crashes when criminal mastermind Maxime Le Mal escapes from prison and vows revenge against Gru.",
    movieThumbnail:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/listing/xxlarge/despicable-me-4-et00386901-1715335701.jpg",
  },
  {
    id: "indian-2",
    name: "Indian 2",
    ratings: "5.2/10",
    votes: "54.5k",
    movieType: "Action, Drama, Thriller",
    poster:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/thumbnail/xlarge/indian-2-et00064311-1720515688.jpg",
    language: ["Hindi", "Tamil"],
    showIn: ["2D"],
    duration: "2h 04m",
    releaseDate: "12 Jul, 2024",
    atm: "In this sequel to the 1996 film Indian, Kamal Hassan reprises his role as Senapathy, an ex-freedom fighter turned vigilante who fights against corruption. Senapathy returns to the country to aid a young man who has been exposing corrupt politicians in the country through videos on the internet.",
    movieThumbnail:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/listing/xxlarge/indian-2-et00064311-1720515688.jpg",
  },
  {
    id: "twisters",
    name: "Twisters",
    ratings: "8.4/10",
    votes: "4.8k",
    movieType: "Action, Adventure, Thriller",
    poster:
      "https://assets-in.bmscdn.com/iedb/movies/images/extra/vertical_logo/mobile/thumbnail/xxlarge/twisters-et00387070-1723539828.jpg",
    language: ["English", "Hindi"],
    showIn: ["2D", "3D", "IMAX 3D"],
    duration: "2h 02m",
    releaseDate: "18 Jul, 2024",
    atm: "Kate Cooper, haunted by a devastating encounter with a tornado during her college years, studies storm patterns on screens safely in New York City. She is lured back to the open plains by her friend, Javi to test a groundbreaking new tracking system. There, she crosses paths with Tyler Owens, the charming and reckless social-media superstar who thrives on posting his storm-chasing adventures with his raucous crew, the more dangerous the better.",
    movieThumbnail:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/listing/xxlarge/twisters-et00387070-1720594533.jpg",
  },
  {
    id: "raayan",
    name: "Raayan",
    ratings: "7.4/10",
    votes: "48.7k",
    movieType: "Action, Crime, Drama",
    poster:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/thumbnail/xlarge/raayan-et00398069-1715682791.jpg",
    language: ["Hindi", "Tamil"],
    showIn: ["2D", "3D", "IMAX #D"],
    duration: "2h 23m",
    releaseDate: "26 Jul, 2024",
    atm: "Raayan features Dhanush in the titular role. The movie is written and directed by Dhanush.",
    movieThumbnail:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/listing/xxlarge/raayan-et00398069-1715682791.jpg",
  },
  {
    id: "inside-out-2",
    name: "Inside Out 2",
    ratings: "9.2/10",
    votes: "31.3k",
    movieType: "Animation, Comedy, Drama",
    poster:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/thumbnail/xlarge/inside-out-2-et00384010-1705486755.jpg",
    language: ["English", "Hindi", "Tamil"],
    showIn: ["2D", "3D", "IMAX 3D", "IMAX 2D"],
    duration: "1h 36m",
    releaseDate: "14 Jul, 2024",
    atm: 'Disney and Pixar`s "Inside Out 2" returns to the mind of newly minted teenager Riley just as headquarters is undergoing a sudden demolition to make room for something entirely unexpected: new emotions! Joy, Sadness, Anger, Fear and Disgust, who`ve long been running a successful operation by all accounts, aren`t sure how to feel when Anxiety shows up. And it looks like she`s not alone.',
    movieThumbnail:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/listing/xxlarge/inside-out-2-et00384010-1705486755.jpg",
  },
  {
    id: "sarfira",
    name: "Sarfira",
    ratings: "8.7/10",
    votes: "30.6k",
    movieType: "Biography, Drama",
    poster:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/thumbnail/xlarge/sarfira-et00387250-1720677970.jpg",
    language: ["Hindi"],
    showIn: ["2D"],
    duration: "2h 35m",
    releaseDate: "12 Jul, 2024",
    atm: "An incredible story, set in the world of startups and aviation, Sarfira will inspire the common man to dream big and to chase your dreams even if the world calls you crazy.",
    movieThumbnail:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/listing/xxlarge/sarfira-et00387250-1720677970.jpg",
  },
  {
    id: "chandu-champion",
    name: "Chandu Champion",
    ratings: "9.2/10",
    votes: "66.3k",
    movieType: "Biography, Drama, Sports",
    poster:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/thumbnail/xlarge/chandu-champion-et00363650-1715754023.jpg",
    language: ["Hindi"],
    showIn: ["2D"],
    duration: "2h 22m",
    releaseDate: "14 Jun, 2024",
    atm: "This is an unbelievable tale of a man who faced one adversary after another with an undying spirit. His unwavering zeal and never-give-up attitude led to the creation of history. This is the story of Chandu Champion!",
    movieThumbnail:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/listing/xxlarge/chandu-champion-et00363650-1715754023.jpg",
  },
  {
    id: "munjya",
    name: "Munjya",
    ratings: "8.2/10",
    votes: "95.7k",
    movieType: "Comedy, Horror",
    poster:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/thumbnail/xlarge/munjya-et00398936-1716358299.jpg",
    language: ["Hindi"],
    showIn: ["2D"],
    duration: "2h 3m",
    releaseDate: "7 Jun, 2024",
    atm: "A young man`s visit to his native village unveils a family secret and a vengeful spirit, Munjya, who wants to get married. Now the young man must fight to protect himself and his love from Munjya`s clutches leading to a humorously chaotic and terrifying adventure.",
    movieThumbnail:
      "https://assets-in.bmscdn.com/iedb/movies/images/mobile/listing/xxlarge/munjya-et00398936-1716358299.jpg",
  },
];
